type BadgeVariant = 'default' | 'success' | 'warning' | 'error' | 'info';

/** Maps HR record status strings to badge variants for consistent UI. */
export function hrStatusBadgeVariant(status: string): BadgeVariant {
  const s = status.toUpperCase();
  if (['APPROVED', 'ACTIVE', 'PRESENT', 'CONFIRMED', 'COMPLETED', 'PAID', 'PROCESSED'].some((x) => s.includes(x))) {
    return 'success';
  }
  if (['PENDING', 'DRAFT', 'SUBMITTED', 'PROBATION', 'IN_PROGRESS', 'OPEN'].some((x) => s.includes(x))) {
    return 'warning';
  }
  if (['REJECTED', 'CANCELLED', 'ABSENT', 'TERMINATED', 'FAILED'].some((x) => s.includes(x))) {
    return 'error';
  }
  if (['ON_LEAVE', 'LEAVE', 'INFO'].some((x) => s.includes(x))) {
    return 'info';
  }
  return 'default';
}

export const HR_LIFECYCLE_EVENT_OPTIONS = [
  { value: 'CONFIRMED', label: 'Confirmed' },
  { value: 'PROMOTION', label: 'Promotion' },
  { value: 'TRANSFER', label: 'Transfer' },
  { value: 'PROBATION', label: 'Probation' },
  { value: 'TERMINATION', label: 'Termination' },
  { value: 'RESIGNATION', label: 'Resignation' },
] as const;
